import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from './auth.store';
import type { Permission } from './roles';

/**
 * Route guard.
 *
 * The old app decided this with `if ((!token || !state || !profile) && !loading)`
 * in the middle of App.js and rendered a completely different router — so an
 * expired session dropped you on the marketing page with no way back to where
 * you were. Here the attempted URL is preserved and replayed after sign-in.
 */
export function RequireAuth({ permission }: { permission?: Permission }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());
  const allowed = useAuthStore((s) => !permission || s.can(permission));
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate to="/login" replace state={{ from: location.pathname }} />
    );
  }

  if (!allowed) return <Navigate to="/unauthorized" replace />;

  return <Outlet />;
}
